<template>
  <div class="pro-plan">
    <CustomTitle :title="mytitle"/>
    <div class="table-header df-c" :style="{
  fontSize: fontsize + 'px',
  lineHeight: (fontsize * 1.25) + 'px'
}">
  <span class="index">#</span>
  <template v-for="(item, index) in tableHeader">
    <!-- 处理客户PO列 -->
    <span v-if="item === '客户PO' && isShowPo === '1'"
          :key="index"
          :style="{flex: '1.7'}">
      {{ item }}
    </span>
    
    <!-- 处理模号列 -->
    <span v-else-if="item === '模号' && isShowMo === '1'"
          :key="index"
          :style="{flex: '1.7'}">
      {{ item }}
    </span>
    
    <!-- 处理其他列 -->
    <span v-else-if="item !== '客户PO' && item !== '模号'"
          :key="index"
          :style="{flex: item === '工号' || item === '图号' ? '2.1' : '1'}">
      {{ item }}
    </span>
  </template>
</div>
    <div class="scroll-chart">
      <vue-seamless-scroll :data="tableData" class="warp" :class-option="classOption">
        <template v-for="(item, index) in tableData">
          <div class="table-item df-c" :key="index" ref="TableItem" 
            :style="{
              fontSize: fontsize + 'px',
              lineHeight: (fontsize * 1.25) + 'px'
            }">
            <span class="index" >{{index+1}}</span> 
            <span class="overflow-text" style="flex:2.1" :style="{color:echodaysColor(item.days)}">{{item.PartNu?item.PartNu.slice(-safePnlen):item.PartNu}}</span>
            <span class="overflow-text" v-if="isShowPo === '1'" style="flex:1.7" :title="item.PO">
              {{item.PO}}</span>
            <span class="overflow-text" v-if="isShowMo === '1'" style="flex:1.7;text-align:center" :title="item.MouldName">{{item.MouldName?item.MouldName.slice(-safePnlen):item.MouldName}}</span>          
            <span class="overflow-text" style="flex:2.1" :style="{color:echodaysColor(item.days)}">{{item.PartTitle?item.PartTitle.slice(-safePnlen):item.PartTitle}}</span>
            <span class="overflow-text" >{{item.Proset}}</span>      
            <span class="overflow-text" :style="{color:echoColor(item.ETED)}">{{echoTime(item.ETED)}}</span>     
            <span class="overflow-text" :style="{color:echoColor(item.PMDDate)}">{{echoTime(item.PMDDate)}}</span>     
            <!--<span class="overflow-text" :style="{color:echoColor(item.CurDEP)}">{{item.CurDEP}}</span>-->
            <span class="overflow-text">{{item.StatusStr}}</span> 
            <span class="overflow-text" :style="{color:echodaysColor(item.days)}" >{{item.days}}</span>
            <!-- "工号,客户PO;模号,图号,数量,部门交期,生管交期,部门,天数" -->
            <!-- <span class="overflow-text">{{item.ETProST}}</span> echodaysColor echodateColor-->
          </div>
        </template>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import CustomTitle from '@/components/CustomTitle'
import vueSeamlessScroll from 'vue-seamless-scroll'
import config from '@/js/config'
import moment from 'moment'

export default {
  name: 'ProductionSchedule',  // Changed from ShippingSchedule to match content
  data () {
    return {
      compid: -1,
      dept: '',
      mytitle: "部门内工件",  // Changed from "今日排程" to be more accurate
      tableHeader: [
        '机台', '工号', '图号', '工时', '状态'
      ],
      tableData: [],
      classOption: {
        step: 0.5
      },
      requestTimer: null,
      isShowPo: '',
      isShowMo: '',
      nowDay: moment().format('YYYY-MM-DD'),
      afterThreeDay: moment().add(2, 'days').format('YYYY-MM-DD'),
      requestUrl: '',
      retryTimer: null,
      classst: '',
      dst: '',
      ded: '',
      fontsize: "",
      pnlen:11,
      emptyDataRefreshInterval: 60 * 1000, // 空数据时1分钟刷新
      normalRefreshInterval: 15 * 60 * 1000 // 正常时15分钟刷新
    }
  },
  methods: {
    getPOparts() {
      clearTimeout(this.retryTimer)
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
      this.classst = window.localStorage.getItem('bsmdayst')
      if(this.classst === 'undefined') {
        this.classst = '8:00'
      }

      var ttp = window.localStorage.getItem('bsmisbrushpcs')
      if(ttp > 0) {
        this.classOption.step = ttp
      }

      var fnt = window.localStorage.getItem('bsmisfontsize')
      if(fnt > 10) {
        this.fontsize = fnt
      }

      this.axios({
        method: 'post',
        url: this.requestUrl + '/admin.php/Bigsreen/deptpartsfun?compid=' + 
             this.compid + '&dept=' + this.dept 
      })
      .then((Response) => {
        var data = JSON.parse(Response.data)
        if (data['rows'] && data['rows'].length > 0) {
          this.tableData = data['rows']
          this.tableHeader = data['head']        
          this.adjustRefreshInterval(this.tableData.length <10);
        }

      })
      .catch((error) => {
        console.log("Error in proplan: ", error)
        // this.retryTimer = setTimeout(() => {
        //   this.getPOparts()
        // }, config.retryTime)
        this.adjustRefreshInterval(true);
      })
    },

    adjustRefreshInterval(isEmpty) {
      clearInterval(this.requestTimer);
      const interval = isEmpty 
        ? this.emptyDataRefreshInterval 
        : this.normalRefreshInterval;
      
      this.requestTimer = setInterval(() => {
        this.getPOparts();
      }, interval);
    },
    
    
    echoTime(time) {
      if (!time) return '';
    
    // 处理包含时间的情况（如 "2023-05-15 14:30:00"）
    const datePart = time.split(' ')[0]; // 取日期部分
    const dateArr = datePart.split('-');
    
    // 确保是有效的日期格式（至少包含年月日）
    if (dateArr.length >= 3) {
      // 返回 "月-日" 格式（如 "05-15"）
      return `${dateArr[1]}-${dateArr[2]}`;
    }
    
    // 如果已经是 "月-日" 格式直接返回
    if (datePart.includes('-') && datePart.split('-').length === 2) {
      return datePart;
    }
    
    // 其他格式原样返回
    return time;
    },
    
    echoColor(time) {
      if (!time) {
        return '#fff'
      }
      if (time != this.dept) {
        return '#FFA8B6'
      }
    },
    // 回显颜色
    echodateColor (time) {
      if (!time) {
        return '#fff'
      }
      if (time < this.nowDay) {
        return '#FFA8B6'
      }
      if (time >= this.nowDay && time <= this.afterThreeDay) {
        return '#FBCF5B'
      }
      return '#fff'
    },
    echodaysColor(dd) {
      if (!dd || isNaN(dd)) return '#fff'
      const days = Number(dd)
      if (days < 2) return '#fff'
      if (days === 2) return '#FFD700'
      return '#FF1493'
    }
  },
  created() {
    this.requestUrl = window.localStorage.getItem('requestUrl')
    this.pnlen = Number(window.localStorage.getItem('bsmpnlen')) || 11;
    // console.log("this.pnlen =",this.pnlen )
    this.getPOparts()
  },
  mounted() {
    this.requestTimer = setInterval(() => {
      this.getPOparts()
    }, 15 * 60 * 1000)  // 15 minutes
  },
  beforeDestroy() {
    clearInterval(this.requestTimer)
    clearTimeout(this.retryTimer)
  },
  components: {
    CustomTitle,
    vueSeamlessScroll
  },
  computed: {
  safePnlen() {
    return Math.abs(parseInt(this.pnlen)) || 11; // 确保是正整数，默认 11
  }
}
}
</script>

<style scoped lang="less">
.pro-plan {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px 8px !important;
  
  .table-header {
    margin-top: 8px;
    background: linear-gradient(0deg, #1b6787 -24.83%, #4aaef7 100%);
    padding: 0 16px;
    border-radius: 8px 8px 0px 0px;
    
    .index {
      width: 20px;
      flex: unset;
    }
    
    span {
      flex: 1;
      padding: 7px 2px;
      text-align: center;
      font-family: 'PingFang SC';
      font-weight: 500;
      color: #ffffff;
      
      &:nth-child(2) {
        flex: 1.7 !important;
      }
    }
  }
  
  .table-item {
    cursor: pointer;
    padding: 0 16px;
    
    .index {
      width: 30px;
      flex: unset;
    }
    
    span {
      flex: 1;
      padding: 5px 2px;
      text-align: center;
      font-family: 'PingFang SC';
      font-weight: 500;
      color: #bae3e6;
      
      &:nth-child(2) {
        flex: 1.7 !important;
      }
    }
  }

  .scroll-chart {
    flex: 1;
    min-height: 100px;
    overflow: hidden;
    border: 1px solid #2dcdff;
    border-top: 0;
    border-radius: 0px 0px 8px 8px;
    
    .warp {
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/workroomdp/components/Deptparts.vue